import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=65596759&"
import script from "./ArticleForm.vue?vue&type=script&lang=js&"
export * from "./ArticleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports